var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"darkPadding"},[_c('label',{staticClass:"toggle"},[_c('img',{staticClass:"cursor-pointer",attrs:{"src":(_vm.mode === 'dark') ?  _vm.Sun  : _vm.Moon},on:{"click":function($event){return _vm.$emit('nightMode')}}})])])}
var staticRenderFns = []

export { render, staticRenderFns }